import { type FC } from "react";
import { useDispatch } from "react-redux";

import { SymbolIcon, TriggerButton, TriggerButtonIntent } from "widgets";

import { type Range } from "../../graphql.js";
import { selectRange } from "../../redux/modules/genome-browser.js";
import { type ReduxDispatch } from "../../redux/redux-utils.js";

export interface ISelectRangeProps {
  range: Range;
}

const SelectRangeButton: FC<ISelectRangeProps> = ({ range }) => {
  const dispatch = useDispatch<ReduxDispatch>();

  return (
    <TriggerButton
      icon={
        <SymbolIcon
          icon={"expand"}
          style={{
            zIndex: 1,
            transform: "rotate(90deg)",
            transformOrigin: "center",
          }}
        />
      }
      // icon={"expand"}
      onPress={() => {
        dispatch(selectRange(range));
      }}
      label={"Select Range"}
      intent={TriggerButtonIntent.Outlined}
      isDisabled={!range}
    />
  );
};

export { SelectRangeButton };
